(function () {
  const searchModal = () => {
    $(".search__form-inner,.search-mobile-trigger").click(function (e) {
      e.preventDefault();
      searchOpen();
    });
    $(".search-modal__overlay,.search__close,.search-mobile-close").click(
      function (e) {
        e.preventDefault();
        searchClose();
      }
    );
  };
  $(document).on("keyup", function (e) {
    if ($(".search-modal").hasClass("active") && e.key == "Escape") {
      searchClose();
    }
  });
  function searchOpen() {
    $("#search-modal").addClass("active");
    if ($("#search-modal").hasClass("active")) {
      $("#search-modal").find(".search__input")[0].focus();
    } else {
      $(".search-modal-trigger").focus();
    }
    $("#search-modal-mobile").addClass("active");
    if ($("#search-modal-mobile").hasClass("active")) {
      $("#search-modal-mobile").find(".search__input")[0].focus();
    } else {
      $(".search-modal-trigger").focus();
    }
    if ($(".search-modal__overlay").hasClass("hide-overlay")) {
      $("body").removeClass("overflow-hidden");
    } else {
      $("body").addClass("overflow-hidden");
    }
    const $header = $(".shopify-section-header");
    if (
      $header.hasClass("header-overlay") &&
      !$(".search-modal__overlay").hasClass("hide-overlay")
    ) {
      $header.removeClass("color-inverse");
    }
  }
  function searchClose() {
    $("#search-modal").removeClass("active");
    if ($("#search-modal").hasClass("active")) {
      $("#search-modal").find(".search__input")[0].focus();
    } else {
      $(".search-modal-trigger").focus();
    }
    $("#search-modal-mobile").removeClass("active");
    if ($("#search-modal-mobile").hasClass("active")) {
      $("#search-modal-mobile").find(".search__input")[0].focus();
    } else {
      $(".search-modal-trigger").focus();
    }
    const element = $(".search-modal__form-main");
    const sec = $(".predictive-search__wrapper");
    if (element.length) {
      if (element.attr("open") !== undefined) {
        element[0].removeAttribute("open");
      }
    }
    $("body").removeClass("overflow-hidden");
    const $header = $(".shopify-section-header");
    if (
      $header.hasClass("header-overlay") &&
      !$header.hasClass("shopify-section-header-sticky")
    ) {
      $header.addClass("color-inverse");
    }
  }
  document.addEventListener("shopify:section:load", searchModal);
  searchModal();
})();
